import React from "react";
import Portfolio from "../component/Portfolio";

export default function PortfolioPag() {
  return (
    <section>
      <Portfolio />
    </section>
  );
}
